import { render, staticRenderFns } from "./VoucherEditor - 副本.vue?vue&type=template&id=4bac6c66&scoped=true"
import script from "./VoucherEditor - 副本.vue?vue&type=script&lang=js"
export * from "./VoucherEditor - 副本.vue?vue&type=script&lang=js"
import style0 from "./VoucherEditor - 副本.vue?vue&type=style&index=0&id=4bac6c66&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac6c66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bac6c66')) {
      api.createRecord('4bac6c66', component.options)
    } else {
      api.reload('4bac6c66', component.options)
    }
    module.hot.accept("./VoucherEditor - 副本.vue?vue&type=template&id=4bac6c66&scoped=true", function () {
      api.rerender('4bac6c66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/gledger/VoucherEditor - 副本.vue"
export default component.exports